import { render, staticRenderFns } from "./playerList.vue?vue&type=template&id=5fdf93d0"
import script from "./playerList.vue?vue&type=script&lang=js"
export * from "./playerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fdf93d0')) {
      api.createRecord('5fdf93d0', component.options)
    } else {
      api.reload('5fdf93d0', component.options)
    }
    module.hot.accept("./playerList.vue?vue&type=template&id=5fdf93d0", function () {
      api.rerender('5fdf93d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/playerList.vue"
export default component.exports